module.exports = __webpack_public_path__ + "img/16l005-07.942a2c0d.jpg";